import React from "react";

const ChangeRequestBadge = () => {
  return (
    <span className="h-fit flex-shrink-0 rounded-sm bg-primary px-1 py-0.5 text-center text-xs text-white">
      変更依頼
    </span>
  );
};

export default ChangeRequestBadge;
